import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
  provideAppInitializer,
  inject,
  APP_ID,
  DEFAULT_CURRENCY_CODE,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { firstValueFrom, forkJoin, switchMap } from 'rxjs';

import { routes } from './app.routes';
import { AuthService } from './core/services/auth.service';
import { DATE_PIPE_DEFAULT_OPTIONS, CurrencyPipe } from '@angular/common';
import { MAT_ICON_DEFAULT_OPTIONS } from '@angular/material/icon';
import { LocationsService, RailcardsService, ReservationService, StationsService } from '@services';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    CurrencyPipe,
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      const locationsService = inject(LocationsService);
      const stationsService = inject(StationsService);
      const railcardService = inject(RailcardsService);
      const reservationService = inject(ReservationService);

      // We only fetch initial app data if we actually have an active access token
      return firstValueFrom(
        authService.getAccessToken().pipe(
          switchMap((token) => {
            if (token) {
              return forkJoin([
                locationsService.getLocations(),
                stationsService.getAllStations(),
                railcardService.getRailcards(),
                reservationService.getSeatProperties(),
              ]);
            } else {
              // If no token, just resolve immediately so the app can route to /login
              return Promise.resolve(null);
            }
          })
        )
      ).then(() => undefined);
    }),
    { provide: APP_ID, useValue: 'staff-journey-planner-app' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'GBP' },
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { timezone: 'Europe/London' },
    },
    { provide: MAT_ICON_DEFAULT_OPTIONS, useValue: { fontSet: 'material-symbols-outlined' } },
  ],
};
